<template>
  <div
    v-if="icone"
    :class="[
      'botao-icone-container',
      { 'botao-icone-arredonda-esquerda': arredondadoEsquerda },
      { 'botao-icone-arredonda-direita': arredondadoDireita },
      cor ? `icone-${cor}` : '',
      { desabilita: desabilita }
    ]"
  >
    <div v-if="loading" class="botao-icone">
      <LoadingPadraoContainerMini delay="5000" :classe="cor" />

      <!-- <i v-if="!tipoLoading || tipoLoading == ''" class="fas fa-spinner fa-spin"></i>
      <LoadingPadrao v-if="tipoLoading == 1" tipo="circulo" escala="0.25" :classe="cor" />
      <LoadingPadrao v-if="tipoLoading == 2" tipo="bloco" tamanho="15" :classe="cor" />
      <LoadingPadrao v-if="tipoLoading == 3" tipo="simples" tamanho="18" :classe="cor" />
      <LoadingPadrao
        v-if="tipoLoading == 4 || tipoLoading == 5"
        tipo="quadrado"
        tamanho="20"
        :classe="cor"
      /> -->
    </div>
    <font-awesome-icon v-else class="botao-icone" :icon="icone" />
  </div>
</template>

<script>
import LoadingPadrao from "../LoadingPadrao/LoadingPadrao.vue";
import LoadingPadraoContainerMini from "@/components/LoadingPadrao/LoadingPadraoContainerMini.vue";

export default {
  name: "BotaoIcone",
  props: {
    icone: String,
    cor: String,
    tipoLoading: String,
    desabilita: Boolean,
    arredondadoDireita: Boolean,
    arredondadoEsquerda: Boolean,
    loading: Boolean
  },
  components: { LoadingPadrao, LoadingPadraoContainerMini }
};
</script>

<style lang="scss" scoped>
.botao-icone-container {
  cursor: pointer;
  transition: all 0.5s ease;
  height: 30px;
  width: 25px;
  background: var(--cinza4);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 2px 2px 4px var(--sombra2);
}
.botao-icone {
  font-size: 14px;
  color: var(--branco);
}
.botao-icone-arredonda-esquerda {
  border-radius: 0 2px 2px 0;
}
.botao-icone-arredonda-direita {
  border-radius: 2px 0 0 2px;
}
.icone-verde {
  background: var(--verde4);
}
.icone-vermelho {
  background: var(--vermelho4);
}
.icone-azul {
  background: var(--azul5);
}
.icone-laranja {
  background: var(--laranja4);
}
.desabilita {
  opacity: 0.5;
  filter: saturate(0.3) contrast(0.4);
  cursor: default;
}
</style>
